import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen">
      <Navbar />

      {/* Hero Section */}
      <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://public.readdy.ai/ai/img_res/a3a14972c64f7f4515d7cfb64350379b.jpg"
            alt="Luxury Airbnb Interior"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/60"></div>
        </div>

        <div className="relative z-10 w-full max-w-5xl mx-auto px-4 sm:px-6 text-center">
          <h1 className="text-3xl sm:text-5xl md:text-7xl font-bold text-white mb-4 sm:mb-6 leading-tight">
            Turn Your Airbnb Into a<br />Revenue Machine<br />
            <span className="text-amber-400">Without the Overwhelm</span>
          </h1>
          <p className="text-base sm:text-xl md:text-2xl text-white/90 mb-8 sm:mb-12 max-w-3xl mx-auto px-2">
            Done-for-you management & expert coaching built in Lagos, proven everywhere
          </p>

          <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center px-4 sm:px-0">
            <Link
              to="/services"
              className="px-6 sm:px-8 py-3 sm:py-4 bg-amber-900 text-white rounded-full text-base sm:text-lg font-medium hover:bg-amber-800 transition-all inline-flex items-center justify-center whitespace-nowrap cursor-pointer"
            >
              Explore Services
              <i className="ri-arrow-right-line ml-2"></i>
            </Link>
            <Link
              to="/get-started"
              className="px-6 sm:px-8 py-3 sm:py-4 border-2 border-white text-white rounded-full text-base sm:text-lg font-medium hover:bg-white hover:text-amber-900 transition-all inline-flex items-center justify-center whitespace-nowrap cursor-pointer"
            >
              Start Your STR Journey
            </Link>
          </div>
        </div>
      </section>

      {/* Value Proposition Section */}
      <section className="py-16 sm:py-24 bg-amber-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="flex flex-col md:flex-row justify-between items-start mb-10 sm:mb-16">
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-4 md:mb-0 md:w-1/2">
              Built in Lagos,<br />Trusted Globally
            </h2>
            <p className="text-base sm:text-lg text-gray-600 md:w-1/2 leading-relaxed">
              We started hosting in one of the world's most challenging cities for short-term rentals. If our systems work in Lagos—with its infrastructure challenges—they work anywhere.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 sm:gap-8">
            <div className="bg-amber-900 rounded-2xl p-6 sm:p-8 text-white">
              <span className="text-xs font-bold uppercase tracking-wider text-amber-300 mb-4 block">
                PROVEN SYSTEMS
              </span>
              <h3 className="text-xl sm:text-2xl font-bold mb-4">4.95 Rating in Lagos</h3>
              <p className="text-amber-100 mb-6 leading-relaxed text-sm sm:text-base">
                Despite electricity, water, and internet challenges, we maintained exceptional guest satisfaction through proprietary systems designed for 5-star experiences.
              </p>
              <div className="relative h-40 sm:h-48 rounded-lg overflow-hidden mt-auto">
                <img
                  src="https://readdy.ai/api/search-image?query=five-star-airbnb-rating-display-with-golden-stars-and-excellent-reviews-showing-high-guest-satisfaction-scores-professional-hospitality-achievement-badge-with-warm-lighting-and-premium-quality-indicators&width=400&height=300&seq=home-rating-proof&orientation=landscape"
                  alt="5-Star Rating"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>

            <div className="bg-white rounded-2xl p-6 sm:p-8 shadow-lg">
              <div className="inline-flex items-center bg-amber-100 text-amber-900 px-3 py-1 rounded-full text-xs font-bold mb-4">
                <i className="ri-home-smile-line mr-1"></i>
                STR MANAGEMENT
              </div>
              <div className="relative h-40 sm:h-48 rounded-lg overflow-hidden mb-6">
                <img
                  src="https://readdy.ai/api/search-image?query=professional-property-management-team-working-on-airbnb-listing-optimization-with-laptop-showing-booking-calendar-and-revenue-analytics-modern-office-setting-with-clean-aesthetic-and-hospitality-focus&width=400&height=300&seq=home-management-service&orientation=landscape"
                  alt="STR Management"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-3">Done-For-You Services</h3>
              <p className="text-gray-600 mb-6 text-sm sm:text-base">
                From listing setup to guest communication, we handle everything so you can focus on growing your portfolio.
              </p>
              <Link
                to="/services"
                className="inline-flex items-center px-6 py-2.5 bg-gray-900 text-white rounded-full text-sm font-medium hover:bg-gray-800 transition-colors whitespace-nowrap cursor-pointer"
              >
                Learn More
              </Link>
            </div>

            <div className="bg-white rounded-2xl p-6 sm:p-8 shadow-lg">
              <div className="inline-flex items-center bg-emerald-100 text-emerald-900 px-3 py-1 rounded-full text-xs font-bold mb-4">
                <i className="ri-graduation-cap-line mr-1"></i>
                COACHING & EDUCATION
              </div>
              <div className="relative h-40 sm:h-48 rounded-lg overflow-hidden mb-6">
                <img
                  src="https://readdy.ai/api/search-image?query=professional-business-coaching-session-with-mentor-teaching-airbnb-hosting-strategies-laptop-displaying-analytics-and-performance-metrics-modern-bright-workspace-with-collaborative-learning-atmosphere-and-success-oriented-environment&width=400&height=300&seq=home-coaching-service&orientation=landscape"
                  alt="Coaching & Education"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-3">Expert Coaching Programs</h3>
              <p className="text-gray-600 mb-6 text-sm sm:text-base">
                Learn our proven systems and strategies to build and optimize your own successful STR business.
              </p>
              <Link
                to="/coaching"
                className="inline-flex items-center px-6 py-2.5 bg-gray-900 text-white rounded-full text-sm font-medium hover:bg-gray-800 transition-colors whitespace-nowrap cursor-pointer"
              >
                Learn More
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Key Benefits Section */}
      <section className="py-16 sm:py-24 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="text-center mb-10 sm:mb-16">
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-4">
              Why Hosts Choose <span className="text-amber-900">Upgraded Version</span>
            </h2>
            <p className="text-base sm:text-lg text-gray-600 max-w-2xl mx-auto">
              We combine hands-on experience with proven systems to help you succeed
            </p>
          </div>

          <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8">
            <div className="text-center">
              <div className="w-14 h-14 sm:w-16 sm:h-16 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-line-chart-line text-2xl sm:text-3xl text-amber-900"></i>
              </div>
              <h3 className="text-base sm:text-xl font-bold text-gray-900 mb-2 sm:mb-3">Revenue Optimization</h3>
              <p className="text-gray-600 text-sm">
                Dynamic pricing strategies and performance optimization to maximize your earnings
              </p>
            </div>

            <div className="text-center">
              <div className="w-14 h-14 sm:w-16 sm:h-16 bg-emerald-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-time-line text-2xl sm:text-3xl text-emerald-900"></i>
              </div>
              <h3 className="text-base sm:text-xl font-bold text-gray-900 mb-2 sm:mb-3">Hands-Off Hosting</h3>
              <p className="text-gray-600 text-sm">
                We handle guest communication, bookings, and operations while you enjoy passive income
              </p>
            </div>

            <div className="text-center">
              <div className="w-14 h-14 sm:w-16 sm:h-16 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-shield-star-line text-2xl sm:text-3xl text-amber-800"></i>
              </div>
              <h3 className="text-base sm:text-xl font-bold text-gray-900 mb-2 sm:mb-3">Proven Systems</h3>
              <p className="text-gray-600 text-sm">
                Battle-tested processes developed in challenging conditions, refined for excellence
              </p>
            </div>

            <div className="text-center">
              <div className="w-14 h-14 sm:w-16 sm:h-16 bg-emerald-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-customer-service-2-line text-2xl sm:text-3xl text-emerald-800"></i>
              </div>
              <h3 className="text-base sm:text-xl font-bold text-gray-900 mb-2 sm:mb-3">15+ Properties Managed</h3>
              <p className="text-gray-600 text-sm">
                Extensive portfolio experience across multiple property types and markets
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="py-16 sm:py-24 bg-gradient-to-br from-amber-900 to-amber-950">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="text-center mb-10 sm:mb-14">
            <span className="text-amber-300 text-sm font-bold uppercase tracking-widest mb-3 block">Client Success Stories</span>
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-4">
              Hosts Who Upgraded Their Results
            </h2>
            <p className="text-white/70 text-base sm:text-lg max-w-2xl mx-auto">
              Real hosts. Real results. From Lagos to beyond.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-8">
            {[
              {
                quote: "Before working with Upgraded Version, my property sat empty most months. Within 60 days of implementing their systems, I went from 30% to 85% occupancy. The revenue increase paid for their services three times over.",
                name: "Adaeze Okonkwo",
                location: "Lagos Host · 2 Properties",
                seq: "testimonial-host-1",
                prompt: "professional-portrait-of-a-confident-Nigerian-woman-in-her-30s-with-natural-hair-wearing-smart-casual-attire-warm-smile-soft-studio-lighting-clean-background-West-African-professional-headshot-photography"
              },
              {
                quote: "I was skeptical at first, but Upgraded Version completely transformed my Lekki apartment. Their pricing strategy alone boosted my monthly income by 40%. The guest communication system is world-class — I barely lift a finger now.",
                name: "Emeka Nwosu",
                location: "Lekki Host · 3 Properties",
                seq: "testimonial-host-2",
                prompt: "professional-headshot-of-a-Nigerian-man-in-his-40s-well-dressed-in-business-casual-shirt-confident-expression-warm-brown-skin-tone-clean-neutral-background-West-African-executive-portrait-photography"
              },
              {
                quote: "The coaching program was a game-changer. I launched my first Airbnb in Abuja with zero experience and hit Superhost status in just 4 months. The step-by-step systems they teach are incredibly practical and easy to follow.",
                name: "Chidinma Eze",
                location: "Abuja Host · New Host",
                seq: "testimonial-host-3",
                prompt: "professional-portrait-of-a-young-Nigerian-woman-in-her-late-20s-with-braided-hair-bright-smile-smart-blouse-warm-skin-tone-clean-light-background-West-African-professional-headshot-modern-photography"
              },
              {
                quote: "I handed over my Victoria Island property to Upgraded Version and never looked back. They handle everything — from guest check-ins to maintenance coordination. My occupancy rate is consistently above 90% every month.",
                name: "Babatunde Adeyemi",
                location: "Victoria Island Host · 5 Properties",
                seq: "testimonial-host-4",
                prompt: "professional-headshot-of-a-Nigerian-man-in-his-50s-distinguished-look-grey-temples-wearing-a-collared-shirt-confident-warm-expression-dark-skin-tone-clean-studio-background-West-African-senior-executive-portrait"
              },
              {
                quote: "Their listing optimization service is unmatched. My photos, description, and pricing were completely overhauled. Within two weeks I had more inquiries than the entire previous quarter. Absolutely worth every naira.",
                name: "Ngozi Obi",
                location: "Port Harcourt Host · 1 Property",
                seq: "testimonial-host-5",
                prompt: "professional-portrait-of-a-Nigerian-woman-in-her-35s-with-short-natural-hair-wearing-a-stylish-top-radiant-smile-medium-brown-skin-tone-bright-clean-background-West-African-businesswoman-headshot-photography"
              },
              {
                quote: "As a diaspora investor, I needed someone I could trust to manage my Ikoyi property remotely. Upgraded Version gave me full transparency, monthly reports, and peace of mind. My property earns while I'm abroad — exactly what I needed.",
                name: "Chukwuemeka Okafor",
                location: "Ikoyi Host · Diaspora Investor",
                seq: "testimonial-host-6",
                prompt: "professional-headshot-of-a-Nigerian-man-in-his-late-30s-clean-shaven-wearing-a-smart-polo-shirt-friendly-confident-smile-dark-brown-skin-tone-neutral-light-background-West-African-professional-portrait-photography"
              }
            ].map((t) => (
              <div key={t.seq} className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 sm:p-8 flex flex-col">
                <div className="flex items-center gap-1 mb-4">
                  {[1,2,3,4,5].map(s => (
                    <i key={s} className="ri-star-fill text-amber-400 text-lg"></i>
                  ))}
                </div>
                <blockquote className="text-white/90 text-sm sm:text-base leading-relaxed flex-1 mb-6">
                  "{t.quote}"
                </blockquote>
                <div className="flex items-center gap-3 sm:gap-4 mt-auto">
                  <div className="w-12 h-12 sm:w-14 sm:h-14 rounded-full overflow-hidden flex-shrink-0">
                    <img
                      src={`https://readdy.ai/api/search-image?query=$%7Bt.prompt%7D&width=120&height=120&seq=${t.seq}&orientation=squarish`}
                      alt={t.name}
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                  <div>
                    <p className="text-white font-bold text-sm">{t.name}</p>
                    <p className="text-amber-300 text-xs">{t.location}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Stats bar */}
          <div className="mt-10 sm:mt-14 grid grid-cols-2 md:grid-cols-4 gap-4 sm:gap-6 border-t border-white/20 pt-8 sm:pt-12">
            <div className="text-center">
              <p className="text-3xl sm:text-4xl font-bold text-white mb-1">15+</p>
              <p className="text-amber-300 text-xs sm:text-sm">Properties Managed</p>
            </div>
            <div className="text-center">
              <p className="text-3xl sm:text-4xl font-bold text-white mb-1">4.95</p>
              <p className="text-amber-300 text-xs sm:text-sm">Average Airbnb Rating</p>
            </div>
            <div className="text-center">
              <p className="text-3xl sm:text-4xl font-bold text-white mb-1">90%+</p>
              <p className="text-amber-300 text-xs sm:text-sm">Avg. Occupancy Rate</p>
            </div>
            <div className="text-center">
              <p className="text-3xl sm:text-4xl font-bold text-white mb-1">5 yrs</p>
              <p className="text-amber-300 text-xs sm:text-sm">Hosting Experience</p>
            </div>
          </div>
        </div>
      </section>

      {/* Final CTA Section */}
      <section className="py-16 sm:py-24 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 text-center">
          <h2 className="text-3xl sm:text-4xl md:text-6xl font-bold text-gray-900 mb-4 sm:mb-6">
            Ready to Upgrade Your Hosting?
          </h2>
          <p className="text-base sm:text-xl text-gray-600 mb-8 sm:mb-10">
            Let's discuss your property and goals
          </p>
          <Link
            to="/get-started"
            className="inline-flex items-center px-8 sm:px-10 py-3 sm:py-4 bg-amber-900 text-white rounded-full text-base sm:text-lg font-medium hover:bg-amber-800 transition-all whitespace-nowrap cursor-pointer"
          >
            Get Started Today
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
        </div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 mt-12 sm:mt-20">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3 sm:gap-4">
            <div className="relative h-36 sm:h-48 rounded-lg overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=modern-airbnb-living-room-with-stylish-furniture-neutral-tones-and-cozy-atmosphere-professional-interior-design-for-short-term-rental-property-with-clean-minimalist-aesthetic&width=400&height=300&seq=home-property-1&orientation=landscape"
                alt="Property 1"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="relative h-36 sm:h-48 rounded-lg overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=elegant-airbnb-bedroom-with-comfortable-bed-soft-lighting-and-premium-bedding-inviting-hospitality-space-with-warm-ambiance-and-boutique-hotel-quality-design&width=400&height=300&seq=home-property-2&orientation=landscape"
                alt="Property 2"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="relative h-36 sm:h-48 rounded-lg overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=contemporary-airbnb-kitchen-with-modern-appliances-clean-countertops-and-functional-design-perfect-for-short-term-rental-guests-bright-and-welcoming-cooking-space&width=400&height=300&seq=home-property-3&orientation=landscape"
                alt="Property 3"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="relative h-36 sm:h-48 rounded-lg overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=beautiful-airbnb-bathroom-with-spa-like-features-clean-tiles-and-luxury-amenities-hotel-quality-hospitality-design-with-attention-to-detail-and-guest-comfort&width=400&height=300&seq=home-property-4&orientation=landscape"
                alt="Property 4"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
